import {AfterViewInit, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../../root/toast/notification.service";
import {ModalService} from "../../../root/modal/modal.service";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {SessionService} from "../../../core/session.service";
import {SidebarService} from "../../../root/sidebar/sidebar.service";
import { } from '@types/googlemaps';
import {BehaviorSubject} from "rxjs";
import {Subject} from "rxjs/Subject";
import {LoggerService} from "../../../core/logger.service";
import {TranslateService} from "@ngx-translate/core";
import {AdditionalPointService} from "../additional-point.service";
import {GeoCodeService} from "../../../core/geo-code.service";
import {AdditionalPointDto} from "../additional-point-dto";
import {AdditionalPoint} from "../additional-point";
import {AdditionalPointValidatorService} from "./additional-point-validator.service";
import {PointOfSaleServiceA2} from "../../pointOfSale/point-of-sale.service";
import {PointOfSaleValidatorService} from "../../pointOfSale/edit/point-of-sale-validator.service";
import {DestinationTypeEnum} from "../../pointOfSale/destination-type.enum";
import {AirportCodeEnum} from "../../pointOfSale/airport-code.enum";
import {TEXT_PATTERN} from "../../../shared/constants/constants";

@Component({
    selector: 'additional-point-edit',
    templateUrl: './additional-point-edit.component.html',
    providers: [AdditionalPointService, GeoCodeService, AdditionalPointValidatorService, PointOfSaleServiceA2, PointOfSaleValidatorService]
})
export class AdditionalPointEditComponent implements OnInit{

    errors:any={};
    companyOid:number;
    countryCode:string='AR';
    id:string;
    isEditing:boolean = false;
    data:any={pointsOfSale:[]};
    endLoading:boolean=false;
    dto:AdditionalPointDto = new AdditionalPointDto();
    additionalPointForm:any;
    additionalPoint:AdditionalPoint;
    warningOn:boolean=false;
    phoneWarningOn:boolean=false;
    countryId:number;
    subject:Subject<any>;
    pointsOfSale:any[];
    enabledCountry:boolean = false;
    enabledCity:number = 0;
    isPointOfSale:boolean=false;
    company_field:string='company';
    pickupPoints:any[];
    posSelected:any = null;
    locationSelected:any = null;
    isValid:boolean=true;
    errorKey:string;
    posError:string = 'pickupPoint.error.pos.location.duplicated';
    pupError:string = 'pickupPoint.error.pup.location.duplicated';

    errorMessages = {
        'requiredAddpuName': 'common.error.REQUIRED',
        'invalidAddpuName': 'common.INPUT_INVALID_TEXT',
        'addpuSurcharge': 'common.error.REQUIRED',
        'addpuPosAssociated': 'common.error.REQUIRED',
        'posLocation': 'common.error.REQUIRED',
    }

    constructor(private addPointService:AdditionalPointService,
                private zone: NgZone,
                private route: ActivatedRoute,
                private toast:NotificationService,
                private navigation:Router,
                private modalService:ModalService,
                private loading:LoadingWheelService,
                private _fb: FormBuilder,
                private sidebar: SidebarService,
                private validator: AdditionalPointValidatorService,
                private sessionService:SessionService,
                private posValidator: PointOfSaleValidatorService,
                private logger: LoggerService,
                private translate: TranslateService,
                private posService: PointOfSaleServiceA2) {

        logger.info('PointOfSaleEditComponent: logger.info()');
    }

    ngOnInit(): void {
        this.subject = new BehaviorSubject(this.dto);

        if(!!this.sessionService.getUserSession() && !!this.sessionService.getUserSession().countryOid) {
            this.countryId = this.sessionService.getUserSession().countryOid;
            this.getAdditionalPointInfo();
        }else{
            this.sessionService.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.countryId = this.sessionService.getUserSession().countryOid;
                    this.getAdditionalPointInfo();
                }
            });
        }
    }

    // This function is a workaround to synchronize something that should be async
    // This kind of code should  be refactored, broken it into smaller parts and try to move towards a FP approach
    private getAdditionalPointInfo() {
        this.sidebar.sidebar = "pickupPoint";
        this.loading.show();

        this.route.params.subscribe(params => {
            this.companyOid = params['companyId'];
            this.id = params['id'];
            this.isEditing = this.id ? this.id != "add" : false;

            this.addPointService.getData(this.companyOid).subscribe((response) => {
                this.data = {pointsOfSale:response[0].map((item) => {
                    return {id:item.oid,
                            value:item.name,
                            pickupPoints:item.pickupPoints,
                            officePointOid:item.officePoint.oid,
                            officePointLocationOid:item.officePoint.locationOid,
                            officePointType:item.officePoint.destinationType};
                    })
                };
                if (this.isEditing) {
                    this.addPointService.getOne(this.companyOid, this.id).subscribe(pos => {
                        this.modelPosView(pos);
                        this.loading.hide();
                        this.endLoading=true;
                        this.posSelected = this.dto.pointOfSaleOid;
                    })
                }else{
                    this.dto.pickupIndications = {meetingType:""};
                    this.loading.hide();
                    this.endLoading=true;
                }

            });
        });
        this.enabledCity = JSON.parse(localStorage.getItem(this.company_field)).cityOid;
    }

    private bindValidations() {
        this.additionalPointForm = this._fb.group({
            addpuName: ['', [Validators.required, Validators.pattern(TEXT_PATTERN)]],
            addpuSurcharge:['', [Validators.required, Validators.pattern(/^[0-9]*((,|\.)[0-9]*)?$/)]],
            addpuPosAssociated: ['', (c: FormControl)=>!!c.value? null:{valid: false}],
            posLocation: ['', this.posValidator.validateLocation],
            posMeetingType: ['', this.posValidator.validateMeetingType],
            posPickupIndications: ['', this.pickupIndicationsValidatorSelector()],

        });
    }

    private pickupIndicationsValidatorSelector() {

        if(this.isMiamiAirport(this.dto.locationOid)) {
            return this.posValidator.validateMiamiPickupIndications;
        }

        if(this.isCancunAirport(this.dto.locationOid)){
            return this.posValidator.validateCancunPickupIndications;
        }

        if(this.isOrlandoAirport(this.dto.locationOid)){
            return this.posValidator.validateOrlandoPickupIndications;
        }

        return this.posValidator.validatePickupIndications;
    }

    private isMiamiAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.MIAMI_AIRPORT;
    }

    private isCancunAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.CANCUN_AIRPORT;
    }

    private isOrlandoAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.ORLANDO_AIRPORT;
    }

    private isSpecialAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.MIAMI_AIRPORT ||
            locationOid == AirportCodeEnum.CANCUN_AIRPORT ||
            locationOid == AirportCodeEnum.ORLANDO_AIRPORT;
    }

    private notNullOrUndefined(c: FormControl){
        return !!c.value && !!c.value.destination && !!c.value.destinationType;
    }

    private bindValues() {
        this.additionalPointForm.controls['addpuName'].setValue(this.dto.name);
        this.additionalPointForm.controls['addpuSurcharge'].setValue(this.dto.surcharge);
        this.additionalPointForm.controls['addpuPosAssociated'].setValue(this.dto.pointOfSaleOid);

        this.additionalPointForm.controls['posLocation'].setValue({
            destination:this.dto.locationName,
            destinationType:this.dto.destinationType,
            street:this.dto.street});

        this.additionalPointForm.controls['posMeetingType'].setValue({
            meetingType: this.isSpecialAirport(this.dto.locationOid) ? "CALL" : this.dto.pickupIndications.meetingType,
            destinationType:this.dto.destinationType,
            street:this.dto.street});

        this.additionalPointForm.controls['posPickupIndications'].setValue(this.bindPickupIndications());
    }

    private bindPickupIndications() {

        if(this.isMiamiAirport(this.dto.locationOid)) {
            return {
                meetingType: "CALL",
                phoneRequired:this.dto.pickupIndications.phoneRequired,
                phoneOptional:this.dto.pickupIndications.phoneOptional,
                miamiAirportPositions: this.dto.pickupIndications.miamiAirportPositions
            }
        }else if(this.isCancunAirport(this.dto.locationOid)){
            return {
                meetingType: this.dto.pickupIndications.meetingType,
                phoneRequired:this.dto.pickupIndications.phoneRequired,
                phoneOptional:this.dto.pickupIndications.phoneOptional,
                cancunAirportPositions: this.dto.pickupIndications.cancunAirportPositions
            }
        }else if(this.isOrlandoAirport(this.dto.locationOid)){
            return {
                meetingType: this.dto.pickupIndications.meetingType,
                phoneRequired:this.dto.pickupIndications.phoneRequired,
                phoneOptional:this.dto.pickupIndications.phoneOptional,
                orlandoAirportPositions: this.dto.pickupIndications.orlandoAirportPositions,
            }
        }
        else {
            return {
                meetingType: this.dto.pickupIndications.meetingType,
                enabledCountry: this.enabledCountry,
                additionalInstructions:this.dto.pickupIndications.additionalInstructions
            }
        }
    }

    save(){
        let pos = this.buildModel(this.dto);
        this.errors = [];
        this.bindValidations();
        this.bindValues();
        let validations = this.validator.validate(this.additionalPointForm);

        if(validations.valid){
            this.zone.run(() => {
                if(!this.isEditing){
                    this.addPointService.save(pos,this.companyOid).subscribe((response) => {
                        this.persistCallback();
                    });
                }else{
                    this.addPointService.update(pos,this.companyOid,this.id).subscribe((response) => {
                        this.persistCallback();
                    });
                }
            })
        }else{
           this.errors = validations.errors;
           if(this.errors) {
               this.toast.notifyErrorByCode('ERROR.required.fields.additional.point');
           }
        }
    }

    private persistCallback(){
        if(this.isEditing){
            this.toast.showToast("pickUpPoint.confirmationMessage.pickUpPoint_edited",null,null,"SUCCESS",5000);
        }else{
            this.toast.showToast("pickUpPoint.confirmationMessage.pickUpPoint_created",null,null,"SUCCESS",5000);
        }

        this.navigation.navigateByUrl('/company/' + this.companyOid+'/pickupPoint');
    }

    public buildModel(dto: AdditionalPointDto) : AdditionalPoint {
        return {
            pointOfSaleOid:dto.pointOfSaleOid,
            surcharge:dto.surcharge,
            name:dto.name,
            locationOid:dto.locationOid,
            locationName:dto.locationName,
            geoLocation:dto.geoLocation,
            street:dto.street,
            typeReference:dto.destinationTypeValue,
            destinationType:dto.destinationType,
            meetingType: dto.pickupIndications.meetingType,
            meetingPhone:dto.meetingPhone,
            pickupIndications:this.buildPickupIndications(dto)
        }
    }

    public buildPickupIndications(dto) {
        if(this.hasPickupIndications(dto.destinationType, dto.pickupIndications)){
            if(this.isMiamiAirport(dto.locationOid)) {
                return {
                    meetingType:'CALL',
                    phoneRequired:dto.pickupIndications.phoneRequired,
                    phoneOptional:dto.pickupIndications.phoneOptional,
                    miamiAirportPositions:dto.pickupIndications.miamiAirportPositions,
                    cancunAirportPositions:null,
                    orlandoAirportPositions:null

                }
            } else if(this.isCancunAirport(dto.locationOid)){
                if(!dto.pickupIndications.cancunAirportPositions.hasCounter){
                    dto.pickupIndications.cancunAirportPositions.counters = null;
                    dto.pickupIndications.meetingType = 'CALL';
                }
                else {
                    dto.pickupIndications.meetingType = 'COUNTER';
                }

                return{
                    meetingType: dto.pickupIndications.meetingType,
                    phoneRequired:dto.pickupIndications.phoneRequired,
                    phoneOptional:dto.pickupIndications.phoneOptional,
                    cancunAirportPositions:dto.pickupIndications.cancunAirportPositions,
                    miamiAirportPositions:null,
                    orlandoAirportPositions:null
                }
            } else if(this.isOrlandoAirport(dto.locationOid)){
                return{
                    meetingType:'RENTAL_SHUTTLE',
                    phoneRequired:dto.pickupIndications.phoneRequired,
                    phoneOptional:dto.pickupIndications.phoneOptional,
                    orlandoAirportPositions:dto.pickupIndications.orlandoAirportPositions,
                    miamiAirportPositions:null,
                    cancunAirportPositions:null
                }
            } else {
                return {
                    meetingType:dto.pickupIndications.meetingType,
                    additionalInstructions:dto.pickupIndications.additionalInstructions
                }
            }
        }

        return {
            meetingType:dto.pickupIndications.meetingType
        }
    }

    hasPickupIndications(destinationType: string, info) {
        return destinationType === DestinationTypeEnum.AIRPORT;
    }

    cancel(){
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.navigation.navigateByUrl(`/company/${this.companyOid}/pickupPoint`));
    }

    setWarning() {
        this.warningOn = true;
        setTimeout(function () {
            this.warningOn = false;
        }, 6000);
    }

    setPhoneWarning() {
        this.warningOn = true;
        setTimeout(function () {
            this.warningOn = false;
        }, 6000);
    }

    public modelPosView(pos: any) {
        this.dto = {
            name:pos.name,
            street:pos.street,
            destinationType:pos.destinationType,
            destinationTypeValue: this.translate.instant("pointOfSale.destinationType." + pos.destinationType),
            surcharge:pos.surcharge,
            pointOfSaleOid:pos.pointOfSaleOid,
            locationName:pos.locationName,
            locationOid:pos.locationOid,
            geoLocation:pos.geoLocation,
            meetingPhone:pos.meetingPhone,
            pickupIndications:!pos.pickupIndications?{meetingType:null} : {
                    meetingType:pos.pickupIndications.meetingType,
                    additionalInstructions:pos.pickupIndications.additionalInstructions,
                    phoneRequired:pos.pickupIndications.phoneRequired,
                    phoneOptional:pos.pickupIndications.phoneOptional}
        };

        if(this.isMiamiAirport(pos.locationOid)){
            this.dto.pickupIndications.miamiAirportPositions = pos.pickupIndications.miamiAirportPositions;
            this.dto.pickupIndications.cancunAirportPositions = null;
            this.dto.pickupIndications.orlandoAirportPositions = null;

        }else if(this.isCancunAirport(pos.locationOid)){
            if(!pos.pickupIndications.cancunAirportPositions.hasCounter){
                pos.pickupIndications.cancunAirportPositions.counters = new Array();
            }

            this.dto.pickupIndications.cancunAirportPositions = pos.pickupIndications.cancunAirportPositions;
            this.dto.pickupIndications.orlandoAirportPositions = null;
            this.dto.pickupIndications.miamiAirportPositions = null;

        }else if(this.isOrlandoAirport(pos.locationOid)){
            this.dto.pickupIndications.orlandoAirportPositions = pos.pickupIndications.orlandoAirportPositions;
            this.setIDs();
            this.dto.pickupIndications.cancunAirportPositions = null;
            this.dto.pickupIndications.miamiAirportPositions = null;
        }

        this.subject.next(this.dto);
    }

    setIDs(){
        for (let i=0;i < this.dto.pickupIndications.orlandoAirportPositions.length; i++) {
            const point = this.dto.pickupIndications.orlandoAirportPositions[i];
            this.dto.pickupIndications.orlandoAirportPositions[i] = {
                id:i,
                terminal:point.terminal,
                stop: point.stop,
                range:point.range
            };
        }
    }

    callingData(event, fromPosSelector) {
        if(fromPosSelector) {
            this.posSelected = event;
        }
        else {
            this.locationSelected = event;
        }
        let pickupPoints;

        if(this.posSelected && this.locationSelected) {
            const selectedPointOfSale = this.data.pointsOfSale.find(pointOfSale => pointOfSale.id === parseInt(this.posSelected));

            if(selectedPointOfSale.officePointLocationOid === parseInt(this.locationSelected.locationOid)
                    && selectedPointOfSale.officePointType === 'AIRPORT') {
                pickupPoints = [selectedPointOfSale.officePointOid];
                this.errorKey = this.posError;
            }
            else {
                if(selectedPointOfSale.pickupPoints) {
                    if(this.isEditing){
                        pickupPoints = selectedPointOfSale.pickupPoints.filter(
                            item => item.locationOid === parseInt(this.locationSelected.locationOid) &&
                                item.destinationType === 'AIRPORT' &&
                                item.oid != this.id);
                    }else{
                        pickupPoints = selectedPointOfSale.pickupPoints.filter(
                            item => item.locationOid === parseInt(this.locationSelected.locationOid) &&
                                item.destinationType === 'AIRPORT'
                        );
                    }
                }
                this.errorKey = this.pupError;
            }

            if(pickupPoints.length) {
                this.cleanIndications();
                this.isValid = false;
            }
            else {
                this.isValid = true;
            }
        }
    }

    cleanIndications() {
        this.dto.pickupIndications.miamiAirportPositions = Array();
        this.dto.pickupIndications.orlandoAirportPositions = undefined;
        this.dto.pickupIndications.cancunAirportPositions = undefined;
        this.dto.pickupIndications.additionalInstructions = "";
        this.dto.pickupIndications.phoneRequired = "";
        this.dto.pickupIndications.phoneOptional = "";
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/edit/additional-point-edit.component.ts